import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/simulatieperinfrastructuur/";

const SimulatiePerInfrastructuurApi = {
	getByInfrastructuur(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId, getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getByInfrastructuurWithForcedValidation(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId + "/validate", getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getNewInfrastructuur() {
		const serviceUrl = prependRoot(routePrefix + "sportinfrastructuurindebuurt", getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(simulatiePerInfrastructuurModel) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.put(serviceUrl, simulatiePerInfrastructuurModel,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	validateSimulatiePerInfrastructuur(simulatiePerInfrastructuur) {
		const serviceUrl = prependRoot(routePrefix + "validateSportInfrastructuurInDeBuurt", getApiRoot());
		return Axios.put(serviceUrl, simulatiePerInfrastructuur, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default SimulatiePerInfrastructuurApi;
